import { pgTable, text, jsonb, timestamp } from "drizzle-orm/pg-core";

// Key/value bag for small storefront settings. Currently holds
// `enabled_locales` (string[] of "lv"|"en"|"ru"); more keys can be added
// without a schema change.
export const storeSettings = pgTable("store_settings", {
  key: text("key").primaryKey(),
  value: jsonb("value").notNull().default({}),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type StoreSetting = typeof storeSettings.$inferSelect;
export type NewStoreSetting = typeof storeSettings.$inferInsert;
